import React from 'react';
import { Hero } from './components/Hero';
import { SkillsSection } from './components/SkillsSection';
import { ProjectsGallery } from './components/ProjectsGallery';
import { ContactSection } from './components/ContactSection';
export function App() {
  return <div className="w-full min-h-screen bg-slate-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SkillsSection data-id="element-2" />
      <ProjectsGallery data-id="element-3" />
      <ContactSection data-id="element-4" />
    </div>;
}